export default {
      id: "share-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#share",
      toString: function () {
        return this.url;
      }
    }